import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallCampaignBackgroundImage } from '../../state/prizeWallCampaign/prizeWallCampaign.slice';
import PrizeWallImage from '../common/PrizeWallImage/PrizeWallImage';

function PrizeWallCampaignBackground() {
  const backgroundImage = useSelector(selectPrizeWallCampaignBackgroundImage);

  return (
    <PrizeWallImage
      {...backgroundImage}
      contentFit="fill"
      position="absolute"
      inset={0}
    />
  );
}

export default memo(PrizeWallCampaignBackground);
